import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appAlphaNumeric]',
  standalone: false
})
export class AlphaNumericDirective {

  constructor() { }
  private regex: RegExp = /^[a-zA-Z0-9]*$/; // Allow only letters and numbers
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight'];

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    const current: string = (event.target as HTMLInputElement).value;
    const next: string = current.concat(event.key);
    if (!this.regex.test(next)) {
      event.preventDefault();
    }
  }
}
